"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _Interactions = _interopRequireDefault(require("./Interactions"));

var _stagingReducer = _interopRequireDefault(require("./stagingReducer"));

var _default = (0, _redux.combineReducers)({
  interactions: _Interactions.default,
  staging: _stagingReducer.default
});

exports.default = _default;
module.exports = exports.default;